import React, { Component, Fragment } from 'react';
import { Row, Col, Divider } from 'antd';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { getContacts, getFooterMenuList } from '../../actions';

//import homeLayout from '../../utils/home.json'
import {loadJson} from '../../utils/loadjson';
const homeLayout = loadJson( '/assets/home.json');
const showFooterMenu = homeLayout.showFooterMenu;


class Footer extends Component {
  componentDidMount() {
    this.props.getContacts();
    this.props.getFooterMenuList();
  }

  render() {
    const { contacts, footerMenu, locale } = this.props;

    return (
      <Col md={{ span: 20, offset: 2 }} lg={{ span: 16, offset: 4 }}>
     {showFooterMenu &&
       <Fragment>
        <Row>
          {footerMenu.map(item => {
            const title = item.title.find(i => i.lang === locale) || item.title[0];
            return (
              <Col key={item._id} xs={24} sm={12} lg={8}>
                <a href={title.url}>
                  <h2>
                    {title.value}
                  </h2>
                </a>
                {item.items && <ul>
                  {item.items.map(i => {
                    const t = i.title.find(i => i.lang === locale) || i.title[0];
                    return (
                      <li key={i._id}>
                        <a href={t.url}>
                          {t.value}
                        </a>
                      </li>
                    );
                  })}
                </ul>}
              </Col>
            );
          })}
        </Row>
        <Divider />
       </Fragment>
       }
       {
        <Fragment>
        <p style={{ textAlign: 'center' }}>
          <FormattedMessage id="Footer.Copyright" />
        </p>
        <p style={{ textAlign: 'center' }}>
          <FormattedMessage id="Footer.DevelopedBy" />
          <a href='https://innoteq.vn' target='_blank' rel='noopener noreferrer'><FormattedMessage id="Footer.Innoteq" /></a>
        </p>
        </Fragment>
        }
      </Col>
    );
  }
}

export default connect(state => ({
  contacts: state.app.contacts,
  footerMenu: state.footerMenu.list,
  locale: state.intl.locale,
}), {
  getContacts,
  getFooterMenuList,
})(Footer);



// WEBPACK FOOTER //
// ./src/components/layouts/Footer.js